<template>
  <div class="nutritions-stucture-bars" @click="showEnergy = !showEnergy">
    <span v-if="!showEnergy" :title="$t(title)" class="nutritions-stucture-bars__title">{{ $t('label.nutritions_structure') }}</span>
    <span v-if="showEnergy" :title="$t(title)" class="nutritions-stucture-bars__title">{{ $t('label.energy_structure') }}</span>
    <div class="nutritions-stucture-bars__progress" v-if="total.kcal === 0">
      <div class="progress-bar progress-bar--no-data">
        {{ $t('label.not_enough_data') }}
      </div>
    </div>
    <div class="nutritions-stucture-bars__progress" v-if="total.kcal > 0">
      <div v-if="bars['procnt'].width > 0"
         class="progress-bar progress-bar--procnt"
        :title="$t(bars['procnt'].title, { value: round(bars['procnt'].value) })"
        :style="{ width: bars['procnt'].width + '%' }">
        {{ $t('label.abbr_protein') }}
      </div>
      <div v-if="bars['chocdf'].width > 0"
         class="progress-bar progress-bar--chocdf"
        :title="$t(bars['chocdf'].title, { value: round(bars['chocdf'].value) })"
        :style="{ width: bars['chocdf'].width + '%' }">
        {{ $t('label.abbr_carbohidrates') }}
      </div>
      <div v-if="bars['fat'].width > 0"
         class="progress-bar progress-bar--fat"
        :title="$t(bars['fat'].title, { value: round(bars['fat'].value) })"
        :style="{ width: bars['fat'].width + '%' }">
        {{ $t('label.abbr_fat') }}
      </div>
      <div v-if="bars['alc'].width > 0"
         class="progress-bar progress-bar--alc"
        :title="$t(bars['alc'].title, { value: round(bars['alc'].value) })"
        :style="{ width: bars['alc'].width + '%' }">
        {{ $t('label.abbr_alcohol') }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { isNil, isEmpty, isArray, isObject, find, each, get, set, has } from 'lodash';
import { numberFormat } from 'utils';

export default {
  name: 'nuttrema-nutritions-stucture-bars',
  props: {
    nutritions: {
      required: true,
      default: null,
    },
    weight: {
      type: Number,
      required: false,
      default: 100,
    },
    width: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      showEnergy: false,
      titles: {
        nutrientBar: 'label.show_nutritions_structure',
        energyBar: 'label.show_energy_structure',
      },
      total: {
        kcal: 0,
        energy: 0,
      },
      elements: {
        procnt: {
          kcal: 35,
          energy: 0,
          nutrientBar: {
            value: 0,
            width: 0,
            title: 'label.contain_protein',
          },
          energyBar: {
            value: 0,
            width: 0,
            title: 'label.energy_from_protein',
          },
          calories: 4,
          code: 'PROCNT',
        },
        chocdf: {
          kcal: 30,
          energy: 0,
          nutrientBar: {
            value: 0,
            width: 0,
            title: 'label.contain_carbohidrates',
          },
          energyBar: {
            value: 0,
            width: 0,
            title: 'label.energy_from_carbohidrates',
          },
          calories: 4,
          code: 'CHOCDF',
        },
        fat: {
          kcal: 40,
          energy: 0,
          nutrientBar: {
            value: 0,
            width: 0,
            title: 'label.contain_fat',
          },
          energyBar: {
            value: 0,
            width: 0,
            title: 'label.energy_from_fat',
          },
          calories: 9,
          code: 'FAT',
        },
        alc: {
          kcal: 10,
          energy: 0,
          nutrientBar: {
            value: 0,
            width: 0,
            title: 'label.contain_alcohol',
          },
          energyBar: {
            value: 0,
            width: 0,
            title: 'label.energy_from_alcohol',
          },
          calories: 7,
          code: 'ALC',
        },
      },
      minBarWidth: 10,
      style: {},
    };
  },
  methods: {
    readValue(input, code) {
      if (isNil(input) || isEmpty(input)) return 0;
      let nutDef;
      let nutritionValue;
      if (isObject(input)) {
        nutDef = isObject(input[code]) ? input[code].nutrition_value : input[code];
        nutritionValue = nutDef || 0;
      } else if (isArray(input)) {
        nutDef = find(input, item => item.code === code);
        nutritionValue = nutDef ? nutDef.NutritionInformation.nutrition_value : 0;
      } else {
        nutDef = input[code];
        nutritionValue = nutDef ? nutDef.nutrition_value : 0;
      }
      return (nutritionValue !== 0) ? Number(this.weight !== 100 ? (nutritionValue * 100) / this.weight : nutritionValue) : 0;
    },
    setValues() {
      if (has(this.nutritions, 'ENERC_KCAL.quantity')) {
        this.setBarsFromResponse();
      } else if (this.nutritions && this.nutritions.length !== 0) {
        each(this.elements, (element) => {
          const kcal = this.readValue(this.nutritions, element.code);
          element.kcal = kcal;
          element.energy = kcal * element.calories;
          this.total.kcal += element.kcal;
          this.total.energy += element.energy;
        });
        this.setBarsManually();
      }
    },
    setBarsFromResponse() {
      let kcal = 0;
      each(this.nutritions, (nutrition) => {
        const code = nutrition.code.toLowerCase();
        set(this.elements[code], 'nutrientBar.value', get(nutrition, 'percent_share_nutrition', 0));
        set(this.elements[code], 'nutrientBar.width', get(nutrition, 'nutrition_structure_bar', 0));
        set(this.elements[code], 'energyBar.value', get(nutrition, 'percent_share_energy', 0));
        set(this.elements[code], 'energyBar.width', get(nutrition, 'energy_structure_bar', 0));
        kcal += get(nutrition, 'percent_share_nutrition', 0);
      });
      this.total.kcal = kcal;
    },
    setBarsManually() {
      let totalNutrientBarWidth = 0;
      let totalEnergyBarWidth = 0;
      let totalCorrectedEnergyBarWidth = 0;

      each(this.elements, (element) => {
        element.nutrientBar.value = element.kcal;
        element.nutrientBar.width = element.kcal === 0 ? 0 : (element.kcal < this.minBarWidth ? this.minBarWidth : element.kcal);
        totalNutrientBarWidth += element.nutrientBar.width;

        const energyBarValue = (element.energy * 100) / this.total.energy;
        element.energyBar.value = energyBarValue;
        element.energyBar.width = energyBarValue === 0 ? 0 : (energyBarValue < this.minBarWidth ? this.minBarWidth : energyBarValue);
        totalEnergyBarWidth += element.energyBar.width;
      });

      if (totalNutrientBarWidth > 100) {
        const diff = totalNutrientBarWidth - 100;
        const element = this.getMax(this.elements, 'nutrientBar.width');
        element.nutrientBar.width -= diff;
      }

      // proportional correct energy bars
      if (totalEnergyBarWidth < 100) {
        each(this.elements, (element) => {
          element.energyBar.width = (element.energyBar.width * 100) / totalEnergyBarWidth;
          totalCorrectedEnergyBarWidth += element.energyBar.width;
        });
      } else {
        totalCorrectedEnergyBarWidth = totalEnergyBarWidth;
      }

      if (totalCorrectedEnergyBarWidth !== 100) {
        const diff = totalCorrectedEnergyBarWidth - 100;
        const element = this.getMax(this.elements, 'energyBar.width');
        element.energyBar.width -= diff;
      }
    },
    getMax(items, key) {
      let max = null;
      each(items, (item) => {
        if (max) {
          const old = get(max, key);
          const current = get(item, key);
          if (current > old) max = item;
        } else {
          max = item;
        }
      });
      return max;
    },
    round(value, decimals = 2) {
      return numberFormat(value, decimals);
    },
  },
  computed: {
    title() {
      return this.showEnergy ? this.titles.nutrientBar : this.titles.energyBar;
    },
    bars() {
      const bars = {};
      const code = this.showEnergy ? 'energyBar' : 'nutrientBar';
      each(this.elements, (element, key) => {
        Vue.set(bars, key, get(element, code));
      });
      return bars;
    },
  },
  watch: {
    nutritions() {
      this.setValues();
    },
  },
  created() {
    this.setValues();
  },
};
</script>

<style lang="scss" scoped>
@import '~assets/styles/theme/content-colors';

$color-primary: #0088cc;
$color-black: #272727;
$color-white: #ffffff;

$color-info: #0088cc; // Blue
$color-success: #377f31; // Green
$color-danger: #880e14; // Red
$color-warning: #dba909; // Yellow
$color-code: #dd1144;

$color-gray-dark: #808080;
$color-gray-light: #e5e5e5;

.nutritions-stucture-bars {
  cursor: pointer;

  .nutritions-stucture-bars__title {
    font-size: 0.8rem;
    text-transform: uppercase;
  }

  .nutritions-stucture-bars__progress {
    height: 15px;
    overflow: hidden;
    min-width: 200px;
    border-radius: 4px;
    text-align: center;
    background-color: $color-gray-light;

    .progress-bar {
      width: 0;
      float: left;
      height: 100%;
      max-width: 100%;
      font-weight: 600;
      line-height: 1rem;
      font-size: 0.75rem;
      color: $color-white;
      box-sizing: border-box;
      transition: width 0.5s ease;
      background-color: $color-primary;
      text-shadow: 0 -1px 0 rgba(0,0,0,0.15);
    }

    .progress-bar--no-data {
      width: 100%;
      background-color: $color-gray-dark;
    }

    .progress-bar--alc {
      background-color: $color-alc;
    }

    .progress-bar--procnt {
      background-color: $color-procnt;
    }

    .progress-bar--chocdf {
      background-color: $color-chocdf;
    }

    .progress-bar--fat {
      background-color: $color-fat;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/label/nuttrema-nutritions-stucture-bars.vue